function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D9DD"
    },
    d: "M160.309,444.174c-5.425-5.425-12.03-8.947-18.987-10.577l73.62-111.108l-12.715-12.715 l-12.715-12.715L78.403,370.679c-1.632-6.958-5.152-13.562-10.577-18.987c-15.516-15.516-40.672-15.516-56.189,0 c-15.516,15.516-15.516,40.673,0,56.189c4.754,4.754,10.415,8.044,16.423,9.885c-9.16,18.469-6.063,41.472,9.321,56.855 c15.383,15.383,38.387,18.481,56.855,9.321c1.841,6.009,5.131,11.669,9.885,16.423c15.516,15.516,40.672,15.516,56.189,0 C175.825,484.847,175.825,459.69,160.309,444.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B9C0"
    },
    d: "M160.309,444.174c-5.425-5.425-12.03-8.947-18.987-10.577l73.62-111.108l-12.715-12.715 c0,0-145.095,145.095-164.846,164.846c15.383,15.383,38.387,18.481,56.855,9.321c1.841,6.009,5.131,11.669,9.885,16.423 c15.516,15.516,40.672,15.516,56.189,0C175.825,484.847,175.825,459.69,160.309,444.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F74D37"
    },
    d: "M46.232,250.295C148.735,125.176,229.44,144.12,229.44,144.12l22.022,22.022l-74.165,105.6 L46.232,250.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C43D2C"
    },
    d: "M261.706,465.769C386.824,363.265,367.88,282.561,367.88,282.561l-22.022-22.022l-105.6,74.165 L261.706,465.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEEF0"
    },
    d: "M454.681,169.143C503.279,80.499,512.001,0,512.001,0s-80.499,8.722-169.143,57.32 C259.73,102.893,169.439,183.532,131.65,324.935l27.708,27.708l27.708,27.708C328.469,342.561,409.107,252.27,454.681,169.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCDEE2"
    },
    d: "M454.681,169.143C503.279,80.499,512.001,0,512.001,0L398.77,113.231L159.358,352.642l27.708,27.708 C328.469,342.561,409.107,252.27,454.681,169.143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCE8F7"
    },
    d: "M364.642,147.358L364.642,147.358c-14.652-14.652-38.491-14.651-53.143,0 c-14.652,14.652-14.652,38.491-0.001,53.143l0,0c14.651,14.651,38.491,14.651,53.143,0 C379.293,185.849,379.293,162.009,364.642,147.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCE8F7"
    },
    d: "M275.76,236.24L275.76,236.24c-14.652-14.652-38.491-14.651-53.143,0 c-14.651,14.651-14.651,38.49,0,53.142l0,0c14.651,14.651,38.491,14.652,53.142,0C290.411,274.733,290.411,250.892,275.76,236.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC1D6"
    },
    d: "M364.642,200.501c14.651-14.652,14.652-38.491,0-53.143l-53.143,53.143 C326.151,215.152,349.99,215.152,364.642,200.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EC1D6"
    },
    d: "M275.759,289.384c14.652-14.651,14.652-38.491,0-53.143l-53.142,53.142 C237.269,304.034,261.108,304.036,275.759,289.384z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D026"
    },
    d: "M512.001,0c0,0-80.499,8.722-169.143,57.32l55.911,55.912l55.912,55.912 C503.279,80.499,512.001,0,512.001,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7C224"
    },
    d: "M454.681,169.143C503.279,80.499,512.001,0,512.001,0L398.77,113.231L454.681,169.143z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.9babba47.svg";
export { ForwardRef as ReactComponent };